/**
 * 카카오톡, 네이버앱에서 다운로드가 동작하지 않아 구별이 필요합니다.
 * @param userAgent
 * @returns {boolean}
 */
export function isBrowserNotDownloadable(userAgent: string): boolean {
  // "; wv" to check the android webview
  // FYR: https://source.chromium.org/chromium/chromium/src/+/main:android_webview/browser/aw_content_browser_client.cc;l=190;drc=8d399817282e3c12ed54eb23ec42a5e418298ec6
  const notDownloadableUASubStrings = ['KAKAOTALK', 'NAVER', '; wv'];
  // 파라미터를 넘기지 않으면 false를 반환한다.

  if (!userAgent) {
    return false;
  }

  return !!notDownloadableUASubStrings.find((keyword) => userAgent.indexOf(keyword) !== -1);
}

/**
 * 브라우저 userAgent 정보를 바탕으로 모바일 디바이스 여부를 반환합니다.
 */
export function isMobileDevice() {
  let isMobile = false;

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (navigator.userAgentData) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    isMobile = navigator.userAgentData.mobile;
  } else {
    // fall back to user-agent string parsing
    // @see: https://dev.to/timhuang/a-simple-way-to-detect-if-browser-is-on-a-mobile-device-with-javascript-44j3
    isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  }

  return isMobile;
}

/**
 * 카카오톡 인앱 브라우저 여부를 반환한다.
 */
export function isKakaoInAppBrowser() {
  return /KAKAOTALK/i.test(navigator.userAgent);
}
